import VueCompositionAPI from "@vue/composition-api";
import Vue from "vue";
import store from "@/store";
import i18n from "@/modules/i18n";
import { setup } from "@/modules/logger";
import PageError from "@/views/PageError.vue";

export function getApp(error: Error) {
  Vue.use(setup, { store });
  Vue.use(VueCompositionAPI);
  return Vue.extend({
    store,
    i18n,
    render: h => h(PageError, { props: { error } }),
  });
}
export function createErrorApp(error: Error) {
  return new (getApp(error))();
}
